import React from 'react'
import { connect } from 'react-redux'
import Col from 'muicss/lib/react/col'
import Prize from './Prize'
import PrizeDialog from '../../PrizeDialog'

const styles = {
  main: {
    marginTop: 10,
  },
  prize: {
    marginBottom: 10,
  },
  empty: {
    textAlign: 'center',
    minHeight: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
}

class PrizesList extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      prizeOpen: false,
    }
  }


  prizeToggleOpen = () => {
    this.setState({
      prizeOpen: !this.state.prizeOpen,
    })
  }

  render = () => (
    this.props.prizes.length > 0 ?
      <div style={styles.main}>
        {this.props.prizes.map(prize =>
          <Col
            style={styles.prize} xs="12" md="6" lg="4"
            key={prize.id} className="mui--text-center"
          >
            <Prize toggleOpen={this.prizeToggleOpen} {...prize} />
          </Col>)
        }
        <PrizeDialog toggleOpen={this.prizeToggleOpen} open={this.state.prizeOpen} />
      </div> :

      <Col xs="12" style={styles.empty}><h1>¡No hay premios disponibles!</h1></Col>
    )

}

const mapStateToProps = state => ({
  prizes: state.user.global_prizes.prizes,
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PrizesList)



// WEBPACK FOOTER //
// ./src/components/Main/Prizes/PrizeList/index.jsx